export enum OrigamiUrlsParams {
  returnRoute = 'return_route',
}
